<!-- eslint-disable -->
<template>
    <div class="row">
        <div class="col-12 col-xl-12 grid-margin stretch-card">
            <div class="card  n">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <h5>
                                Recherche
                            </h5>
                        </div>
                    </div>
                    <div class="row">
                        <div v-if="operation" class="col-md-6 mb-3">
                            <label class="form-label">Operation :</label>
                            <select class="form-select btn-outline-primarys dropdown-toggle"
                                @change="onChangeSelectOperation()" v-model="SelectedOperation">
                                <option selected value="all">
                                    Toutes Operations.
                                </option>
                                <option v-for="(operation, index) in data?.operations" v-bind:key="`Operation-${index}`"
                                    :value="operation">{{
                                    index
                                    +
                                    1
                                    }}&nbsp;&nbsp;-&nbsp;&nbsp;{{ operation.toUpperCase() }}</option>
                            </select>
                        </div>
                        <div v-if="etat" class="col-md-6 mb-3">
                            <label class="form-label">Etats :</label>
                            <select class="form-select btn-outline-primarys dropdown-toggle"
                                @change="onChangeSelectEtat()" v-model="SelectedEtat">
                                <option selected value="all">
                                    Toutes Etats sans ouvert
                                </option>
                                <option v-for="(etat, index) in data?.etats" v-bind:key="`etat-${index}`" :value="etat">
                                    {{ index + 1 }}&nbsp;&nbsp;-&nbsp;&nbsp; {{ etat.toUpperCase() }}</option>
                            </select>
                        </div>
                        <div v-if="caisse" class="col-md-6 mb-3">
                            <label class="form-label">Caisse :</label>
                            <select class="form-select btn-outline-primarys dropdown-toggle"
                                @change="onChangeSelectCaisse()" v-model="SelectedCaisse">
                                <option selected value="all">
                                    Toutes caisses.
                                </option>
                                <option v-for="(caisse, index) in listCaisses" v-bind:key="`caisse-${index}`"
                                    :value="JSON.stringify(caisse)">{{
                                    index
                                    +
                                    1
                                    }}&nbsp;&nbsp;-&nbsp;&nbsp; {{ caisse.LibCaisse.toUpperCase() }}</option>
                            </select>
                        </div>
                        <div v-if="vendeur" class="col-md-6 mb-3">
                            <label class="form-label">Vendeur :</label>

                            <select class="form-select btn-outline-primarys dropdown-toggle"
                                @click="onChangeSelectVendeur()" v-model="SelectedVendeur">
                                <option selected value="all">
                                    Toutes vendeurs.
                                </option>
                                <option v-for="(vendeur, index) in listVendeurs" v-bind:key="`vendeurs-${index}`"
                                    :value="JSON.stringify(vendeur)"> {{ vendeur.LibVendeur.toUpperCase() }}</option>
                            </select>
                        </div>


                        <div v-if="isNumTicket" class="col-md-6 mb-3  ">
                            <div class="w-100  ">
                                <label for="Date" class="form-label">Numéro du ticket</label>
                                <input type="text" class="form-control" placeholder="Nom du Restaurant"
                                    v-model="globalSearch.NumTicket" />
                            </div>
                        </div>
                        <div v-if="isMontantTtc" class="col-md-6 mb-3  ">
                            <div class="w-100  ">
                                <label for="Date" class="form-label">Montant TTC</label>
                                <input type="text" class="form-control" placeholder="Nom du Restaurant"
                                    v-model="globalSearch.MontantTTC" />
                            </div>

                        </div>

                        <div v-if="date" class="col-md-12 mb-3  ">
                            <div class="w-100  ">
                                <label for="Date" class="form-label">Dates</label>
                                <VueDatePicker locale="fr" @update:model-value="handleDate" v-model="selectedDates"
                                    :action-row="{ showSelect: false, showCancel: false }" range multiCalendars
                                    :enableTimePicker="true" format="dd-MM-yyyy HH:mm" close-on-scroll auto-apply
                                    show-now-button />
                            </div>

                        </div>

                        <div class="col-md-12 mt-4 d-flex ">
                            <button @click="clearFilter" class="  btn btn-secondary   text-white w-50 ms-3">
                                Vider </button>
                            <button @click="search" class="  btn btn-primary text-white w-50 ms-3">
                                Chercher</button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<!-- eslint-disable -->
<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { DateTime } from "luxon";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { isMoreThan24HoursFake, hasValidDateRange } from '@/Utils/useDateDiff'

export default {
    components: { VueDatePicker },
    props: ['operation', 'etat', 'caisse', 'vendeur', 'date', 'vendeurStaus', 'isNumTicket', 'isMontantTtc'],
    data() {
        return {
            selectedDates: [],
            data: {
                caisses: [],
                vendeurs: [],
                etats: ["Ouvert"],
                operations: ['VENTE', 'TRANSFERT', 'ANNULATION'],
            },
            SelectedVendeur: {},
            SelectedCaisse: {},
            SelectedEtat: "all",
            SelectedOperation: "all", 
        }
    },
    async created() {
        await this.$store.dispatch('loadParametrages');
        // Wait until parametrages are loaded
        if (this.date)
            this.setDefaultDates()
        console.log("created default val datepicker")
        const get = async () => {
            if (this.currentSite?._id) {
                if (this.listVendeurs?.length <= 0)
                    await this.getListVendeurs();
                if (this.listCaisses?.length <= 0)
                    await this.getListCaisses()
            }
        };
        if (this.isAuthenticated && this.isRole == 'manager')
            get();

        this.clearFilter()
    },

    mounted() {
        //this.setDefaultDates()
        //console.log("mounted default val datepicker")

        // const get = async () => {
        //     if (this.currentSite?._id) {
        //         if (this.listVendeurs?.length <= 0)
        //             await this.getListVendeurs();
        //         if (this.listCaisses?.length <= 0)
        //             await this.getListCaisses()
        //     }
        // };
        // if (this.isAuthenticated && this.isRole == 'manager')
        //     get();

        // this.clearFilter()
    },

    methods: {
        ...mapActions(["getVendeurs", "getCaisses"]),
        async getListVendeurs() {
            const siteID = (this.currentSite != undefined) ? this.currentSite?._id : 'site'
            await this.getVendeurs({
                url: "vendeurs",
                site: siteID,
                vendeur: "vendeur",
                isActive: this.vendeurStaus == 'all' ? [true, false] : [true]
            });
        },
        async getListCaisses() {
            const siteID = (this.currentSite != undefined) ? this.currentSite?._id : 'site'
            await this.getCaisses({
                url: "entetes/caisses",
                site: siteID,
                caisses: 'caisses'
            });
        },
        clearFilter() {
            this.SelectedCaisse = "all"
            this.globalSearch.SelectedLibCaisses = []
            this.SelectedVendeur = "all"
            this.globalSearch.SelectedLibVendeurs = []
            this.SelectedEtat = "all"
            this.globalSearch.SelectedEtats = []
            this.SelectedOperation = "all"
            this.globalSearch.SelectedOperations = []
            this.globalSearch.NumTicket = null
            this.globalSearch.MontantTTC = null
            this.$emit('search');
        },
        onChangeSelectOperation() {
            if (this.SelectedOperation == "all") {
                this.globalSearch.SelectedOperations = []
            } else if (this.SelectedOperation === "TRANSFERT") {
                this.globalSearch.SelectedOperations = []
                this.globalSearch.SelectedOperations = ["TRANSFERT", "TRANSFERT-TABLE"]
            } else {
                const Operation = this.SelectedOperation
                this.globalSearch.SelectedOperations = []
                this.globalSearch.SelectedOperations.push(Operation);
            }
        },
        onChangeSelectEtat() {
            if (this.SelectedEtat == "all" || this.SelectedEtat == "Autres") {
                this.globalSearch.SelectedEtats = []
            } else {
                const etat = this.SelectedEtat
                if (this.globalSearch.SelectedEtats?.length)
                    this.globalSearch.SelectedEtats.splice(0, 1);
                this.globalSearch.SelectedEtats.push(etat);
            }

        },
        onChangeSelectCaisse() {
            if (this.SelectedCaisse == "all") {
                this.globalSearch.SelectedLibCaisses = []
            } else {
                const caisse = JSON.parse(this.SelectedCaisse)
                if (this.globalSearch.SelectedLibCaisses?.length)
                    this.globalSearch.SelectedLibCaisses.splice(0, 1);
                this.globalSearch.SelectedLibCaisses.push(caisse?.LibCaisse);

            }

        },
        onChangeSelectVendeur() {
            if (this.SelectedVendeur == "all") {
                this.globalSearch.SelectedLibVendeurs = []
            } else {
                const vendeur = JSON.parse(this.SelectedVendeur)
                if (this.globalSearch.SelectedLibVendeurs?.length)
                    this.globalSearch.SelectedLibVendeurs.splice(0, 1);
                this.globalSearch.SelectedLibVendeurs.push(vendeur?.LibVendeur);

            }
        },
        search() {
            // Emit a custom event with the search title
            this.$emit('search');
        },

        handleDate(selectedDate) {
            if (this.date) {
                if (!selectedDate) {
                    this.setDefaultDates();
                    return;
                }

                const [fromHour = '00', fromMinutes = '00'] = this.parametrages?.calculeTicket?.TimeDebut?.split(':') || [];
                const [toHour = '23', toMinute = '59'] = this.parametrages?.calculeTicket?.TimeFin?.split(':') || [];

                const dateFrom = DateTime.fromFormat(
                    this.$dayjs(selectedDate[0]).format('YYYY-MM-DD HH:mm'),
                    'yyyy-MM-dd HH:mm'
                ).set({ second: 0, millisecond: 0 });
                let dateTo = DateTime.fromFormat(
                    this.$dayjs(selectedDate[1]).format('YYYY-MM-DD HH:mm'),
                    'yyyy-MM-dd HH:mm'
                ).set({ second: 0, millisecond: 0 });

                const dateNFrom = dateFrom.minus({ year: 1 });
                let dateNTo = dateTo.minus({ year: 1 });

                if (+fromHour > 0) {
                    dateTo = dateTo.plus({ day: 1 }).set({ second: 0, millisecond: 0 });
                    dateNTo = dateNTo.plus({ day: 1 }).set({ second: 0, millisecond: 0 });
                }

                const formattedDateFrom = dateFrom.toISO({ includeOffset: false, suppressMilliseconds: false });
                const formattedDateTo = dateTo.toISO({ includeOffset: false, suppressMilliseconds: false });

                this.datePicker.date = {
                    from: dateFrom.toFormat('MM-dd-yyyy HH:mm'),
                    to: dateTo.toFormat('MM-dd-yyyy HH:mm'),
                    range: [formattedDateFrom, formattedDateTo]
                };
                this.datePicker.defaultDates.type = null;
            }
            
            
        },
        async setDefaultDates() {
            const hasRangeDate = await hasValidDateRange(this.datePicker)
            console.log("hasRangeDate")
            console.log(hasRangeDate)
            if (hasRangeDate) {
                this.selectedDates = [this.datePicker.date.range[0], this.datePicker.date.range[1]];
                return;
            } else {
                console.log('hello ayoub ============')
                const timeZone = 'Europe/Paris';
                const now = DateTime.now().setZone(timeZone);

                const [fromHour = '00', fromMinutes = '00'] = this.parametrages?.calculeTicket?.TimeDebut?.split(':') || [];
                const [toHour = '23', toMinute = '59'] = this.parametrages?.calculeTicket?.TimeFin?.split(':') || [];

                const dateFrom = now.set({ hour: +fromHour, minute: +fromMinutes, second: 0, millisecond: 0 });
                const dateTo = dateFrom.set({ hour: +toHour, minute: +toMinute, second: 0, millisecond: 0 });

                const formattedDateFrom = dateFrom.toISO({ includeOffset: false, suppressMilliseconds: false });
                const formattedDateTo = dateTo.toISO({ includeOffset: false, suppressMilliseconds: false });

                this.datePicker.date = {
                    from: dateFrom.toFormat('MM-dd-yyyy HH:mm'),
                    to: dateTo.toFormat('MM-dd-yyyy HH:mm'),
                    range: [formattedDateFrom, formattedDateTo]
                };

                this.selectedDates = [formattedDateFrom, formattedDateTo];
            }




        }
    },
    computed: {
        ...mapGetters({ listVendeurs: "listVendeurs", listCaisses: "listCaisses", isRole: "isRole", isAuthenticated: "isAuthenticated", res: "StateRes", currentSite: "currentSite", parametrages: "StateParametrages", TimeDebutCalclule: "TimeDebutCalclule" }),
        ...mapState(["globalSearch", "datePicker"]),
    }
}
</script>
<!-- eslint-disable -->
<style scoped >
    label{
        font-weight: bold;
    }
</style>